const colors = {
  primary: {
    // default: '#CF1F2E',
    default: '#4CAF50',
  },
  secondary: {
    default: '#1B1B1B',
    1: '#ED7064',
    2: '#EBAB33',
    3: '#009783',
    4: '#0475BC',
  },
  tertiary: {
    1: '#F8D2CB',
    2: '#FFF2DF',
    3: '#C5E4C8',
    4: '#D1E8F8',
  },
  semantics: {
    default: '#1B1B1B',
    'link-light': '#EFF7FB',
    link: '#0475BC',
    'error-light': '#FEF5F8',
    error: '#EB003B',
    'success-light': '#ECF6F4',
    success: '#00856D',
    'success-dark': '#006A57',
    'info-light': '#F3F3F3',
    info: '#757575',
    'info-dark': '#454545',
    'warning-light': '#F8F3EC',
    warning: '#A85D00',
    disabled: '#CDCDCD',
  },
  gray: {
    0: '#FFFFFF',
    50: '#F6F6F6',
    100: '#F2F2F2',
    200: '#EAEAEA',
    300: '#CDCDCD',
    400: '#AEAEAE',
    500: '#909090',
    600: '#757575',
    700: '#5F5F5F',
    800: '#454545',
    900: '#303030',
    1000: '#1B1B1B',
    1100: '#000000',
  },
  blue: {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976D2',
    800: '#1565c0',
    900: '#0d47a1',
  },
  green: {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
  },
};

export default colors;
